import { ServerResponse } from "./http/settings";
import { PostRequest } from "./http/BaseRequest";
import { ALGOS_E } from "@constants/Algos";
import { IAdminMinerTable } from "./getMinerInfo";

export interface NewMinerI extends IAdminMinerTable {
  readonly isNew?: boolean;
}

export const isNewMiner = (miner: IAdminMinerTable): miner is NewMinerI =>
  (miner as NewMinerI).isNew !== undefined;

export interface AddMinerResponse extends ServerResponse {
  Record: NewMinerI; // new miner
}

export interface IAddMinerParams {
  hash: ALGOS_E;
  admin_text?: string;
  speed_drops?: number;
  miner_type?: string;
  mining_persent?: number;
  default_speed?: number;
  miner_plan?: string;
  admin_setting?: string;
  location_id?: string;
  customer?: string;
  pool_id?: string;
}

export class AddMinerReuest extends PostRequest {
  constructor(savedSettings: IAddMinerParams) {
    super("/admin/miner/add", { ...savedSettings });
  }
}
